export default "__VITE_ASSET__Bb4rEMK2__"